type ApiWindow = Window & {
  __APP_CONFIG__?: { apiBaseUrl?: string; apiUrl?: string }
  API_BASE_URL?: string
  API_URL?: string
}

let cachedApiBase: string | null | undefined

const ABSOLUTE_URL = /^https?:\/\//i
const DEFAULT_ORIGIN = 'http://localhost'
const DEFAULT_API_BASE = '/api'

const getGlobalWindow = () => (typeof window !== 'undefined' ? (window as ApiWindow) : undefined)

const normalizeBaseUrl = (value: string, origin: string) => {
  const base = new URL(value, origin)
  base.hash = ''
  const normalized = base.toString()
  return normalized.endsWith('/') && normalized !== `${base.protocol}//${base.host}/`
    ? normalized.slice(0, -1)
    : normalized
}

const resolveApiBase = () => {
  if (cachedApiBase !== undefined) return cachedApiBase

  const globalWindow = getGlobalWindow()
  const origin = globalWindow?.location?.origin ?? DEFAULT_ORIGIN
  const env = (import.meta as any)?.env ?? {}

  const candidates = [
    env.VITE_API_BASE_URL,
    env.API_BASE_URL,
    env.API_URL,
    globalWindow?.__APP_CONFIG__?.apiBaseUrl,
    globalWindow?.__APP_CONFIG__?.apiUrl,
    globalWindow?.API_BASE_URL,
    globalWindow?.API_URL,
  ].filter((value): value is string => Boolean(value))

  for (const candidate of candidates) {
    try {
      cachedApiBase = normalizeBaseUrl(candidate, origin)
      return cachedApiBase
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[api] Ignoring invalid API base URL', candidate, error)
      }
    }
  }

  cachedApiBase = DEFAULT_API_BASE
  return cachedApiBase
}

export const getApiBaseUrl = () => resolveApiBase()

export const buildApiUrl = (path: string) => {
  if (ABSOLUTE_URL.test(path)) return path

  const base = resolveApiBase()
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (!base) return normalizedPath
  if (base.endsWith('/')) return `${base.slice(0, -1)}${normalizedPath}`
  return `${base}${normalizedPath}`
}
